<template>
  <div class="investDetail">
  	<van-row class="investDetail-wrap" :class="{'isiOSX':isiOSX}">
  		<img class="bg" :src="info.poster" @error="nofind()"/>
		  <van-col class="back" span="24"><img @click="prev" src="../../assets/myInvest/goBack.png"/></van-col>
		  <van-col class="describe" span="24">
		  	<div class="info">
		  		<span class="border"></span>
		  		<p class="name">{{info.project_name}}</p>
		  		<!-- <p class="msg" v-if="info.order_count && info.member_order_exist">当前已有{{info.order_count.member_count}}人认购{{info.order_count.shares_sum}}股</p> -->
		  		<img class="label" v-if="info.project_type == 1 && info.status == 1" src="../../assets/myInvest/label_1.png"/>
		  		<img class="label" v-if="info.project_type == 2 && info.status == 1" src="../../assets/myInvest/long.png"/>
		  		<img class="label" v-if="info.status == 2 || info.status == 3 || info.status == 4" src="../../assets/myInvest/finished.png">
		  		<img class="label" v-if="info.status == -1 || info.status == -2 || info.status == -3" src="../../assets/myInvest/failed.png">
		  	</div>
		  	<p class="speed" v-if="info.project_type == 1 && info.member_order_exist"><span :style="{width:info.prograss+'%'}"></span></p>
		  	<p class="prograss" v-if="info.project_type == 1">剩余 {{info.surplus}}天<span>目标{{info.target_shares}}股</span></p>
		  </van-col>
		</van-row>
		<van-row class="investDetail-detail">
			<van-col span="24" class="address"><img src="../../assets/myInvest/address.png" />{{info.invest_store_address}}</van-col>
		  <van-col class="title" span="24"><span></span>项目描述</van-col>
		  <van-col class="box" span="24" v-html="info.detail">
		  </van-col>
		</van-row>	
    <van-goods-action v-if="info.status == 1">
			<van-button size="large" @click="submit"><img src="../../assets/myInvest/join.png" />我要参与</van-button>
	  </van-goods-action>
  </div>
</template>

<script>
import defaultImg from '@/assets/common/ListPreload.png';
export default {
  data() {
    return {
      info: {},
      isiOSX: false
    };
  },
  created(){
　　this.getInfo();
		this.isiOSX = this.isIphoneX();
  },
  methods: {
    getInfo() {
    	this.$api.get("/investment/member/project/detail", {id:this.$route.query.id}).then(res => {
	        if(res.project_type == 1){
	        	res.surplus = this.timeDiff(res.invest_end_time);
	        	if(res.member_order_exist) {
	        		res.prograss = res.order_count.shares_sum / res.target_shares * 100;
			    		if(res.prograss < 1) {
			    			res.prograss = 1;
			    		}
	        	}
	        }
	        this.info = res;
	    });
    },
    timeDiff(end_time) {
  		var endTime = this.date2timestamp(end_time);
  		var current = Math.floor(new Date().getTime() / 1000);
  		var ts = endTime - current;
  		if(ts <= 0){
  			return 0;
  		}else {
  			var dd = parseInt(ts / 60 / 60 / 24, 10);
  			return dd;
  		}
  	},
  	prev() {
  		this.$router.go(-1);
  	},
  	submit() {
  		this.$router.push({
	      path: "/myInvest/addIn",
	      query: {
	        id: this.info.id
	      }
    	});
  	},
  	nofind() {
	    var img = event.srcElement;
			img.src = defaultImg;
			img.onerror = null; //防止闪图
		}
  },
  mounted() {
	  
  }
};
</script>

<style lang="less">
.investDetail {
	height: 100%;
	overflow-y: scroll;
	-webkit-overflow-scrolling:touch;
	.van-goods-action {
		.van-button {
			color: #fff;
			font-size: 16px;
			font-weight: bold;
			height: 49px;
			line-height: 49px;
			background: #C49E80;
			border: none;
			img {
				vertical-align: middle;
				margin-top: -3px;
				margin-right: 9px;
				width: 13px;
			}
		}
	}
	&-wrap {
		height: 281px;
		position:relative;
		.bg {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			left: 0;
			background: #f5f5f5;
		}
		.back {
			position: absolute;
			left: 0;
			top: 0;
			padding: 36px 8px 0;
			img {
				width: 52px;
			}
			@media only screen and (min-width: 320px) and (max-width: 374px){
	      img {
	        width: 43px;
	      }
	    }
		}
		.describe {
			padding: 16px 16px 20px;
			position: absolute;
			left: 0;
			bottom: 0;
			color: #fff;
			background: -webkit-linear-gradient(rgba(255, 255, 255, 0), rgba(0, 0, 0, .9)); /* Safari 5.1 - 6.0 */
	    background: -o-linear-gradient(rgba(255, 255, 255, 0), rgba(0, 0, 0, .9)); /* Opera 11.1 - 12.0 */
	    background: -moz-linear-gradient(rgba(255, 255, 255, 0), rgba(0, 0, 0, .9)); /* Firefox 3.6 - 15 */
	    background: linear-gradient(rgba(255, 255, 255, 0), rgba(0, 0, 0, .9));
			.info {
				padding: 0 84px 0 12px;
				position:relative;
				.border {
					width: 4px;
					height: calc(100% - 4px);
					background: #F0E0D3;
					position: absolute;
					bottom: 0;
					left: 0;
				}
				.name {
					font-size: 28px;
					line-height: 36px;
					font-weight: 700;
				}
				.msg {
					height: 20px;
					line-height: 26px;
				}
				.label {
					position: absolute;
					bottom: 0;
					right: 0;
					width: 84px;
				}
				@media only screen and (min-width: 320px) and (max-width: 374px){
		      .name {
		        font-size: 22px;
						line-height: 30px;
		      }
		    }
			}
			.speed {
				height: 3px;
				border-radius: 2px;
				position: relative;
				margin-top: 20px;
				background: rgba(255, 255, 255, .3);
				span {
					width: 30%;
					height: 3px;
					display: inline-block;
					border-radius: 2px;
					background: #fff;
					position: absolute;
					top: 0;
					left: 0;
				}
			}
			.prograss {
				line-height: 20px;
				margin-top: 12px;
				span {
					float: right;
				}
			}
			@media only screen and (min-width: 320px) and (max-width: 374px){
		    .info {
	      	margin-bottom: 13px;
	      }
	      .prograss {
					margin-top: 8px;
					font-size: 12px;
				}
	    }
		}
	}
	.isiOSX{
		.back{
			padding-top: 56px;
		}
	}
	&-detail {
		padding: 8px 16px 56px;
		.address {
			color: #C0C0C0;
			font-size: 13px;
			height: 26px;
			line-height: 26px;
			img {
				width: 17px;
				float: left;
				margin-top: 4px;
				margin-right: 6px;
			}
		}
		.title {
			color: #333;
			font-size: 18px;
			font-weight: 700;
			height: 41px;
			line-height: 41px;
			position: relative;
			padding-left: 12px;
			span {
				width: 3px;
				height: 16px;
				background: #333;
				display: inline-block;
				position: absolute;
				top: 11px;
				left: 0;
			}
		}
		@media only screen and (min-width: 320px) and (max-width: 374px){
      .title {
        font-size: 16px;
				height: 36px;
				line-height: 36px;
				span {
					height: 14px;
				}
      }
    }
		.box {
			width: 100% !important;
			border-radius: 3px !important;
			font-size: 14px !important;
			color: #666 !important;
			* {
				width: 100% !important;
				border-radius: 3px !important;
				font-size: 14px !important;
				color: #666 !important;
			}
		}
	}
	@media only screen and (min-width: 320px) and (max-width: 374px){
	  &-wrap {
	    height: 239px;
	  }
	  
	}
  
}

</style>
